export const SP_ORDER_COMMENTS_LIST_FILTERED = "SP_ORDER_COMMENTS_LIST_FILTERED";
export const SP_ORDER_COMMENTS_LIST_FILTERED_SUCCESS = "SP_ORDER_COMMENTS_LIST_FILTERED_SUCCESS";
export const SP_ORDER_COMMENTS_LIST_FILTERED_ERROR = "SP_ORDER_COMMENTS_LIST_FILTERED_ERROR";
export const SP_ORDER_COMMENT_CREATE = "SP_ORDER_COMMENT_CREATE";
export const SP_ORDER_COMMENT_CREATE_SUCCESS = "SP_ORDER_COMMENT_CREATE_SUCCESS";
export const SP_ORDER_COMMENT_CREATE_ERROR = "SP_ORDER_COMMENT_CREATE_ERROR";